

export default class {
    constructor($el, windowPal) {
        this.$ = $el;
        this.windowPal = windowPal;
        this.srcDesktop = $el.css('background-image');
        this.srcMobile = 'url("' + $el.data('mobile-bg') + '")';
        this.isMobile = null;
        // console.log(this.srcDesktop, this.srcMobile);
        windowPal.resize(()=>{
            this.checkScreenWidth();
        });
        this.checkScreenWidth();
    }
    checkScreenWidth() {
        let windowWidth = this.windowPal.$.width();
        if (windowWidth > 950) {
            if (this.isMobile !== false) {
                this.isMobile = false;
                this.setAsDesktop();
            }
        } else {
            // console.log('setAsMobile');
            if (this.isMobile !== true) {
                this.isMobile = true;
                this.setAsMobile();
            }
        }
    }
    setAsDesktop() {
        this.$.css('background-image', this.srcDesktop);
    }
    setAsMobile() {
        this.$.css('background-image', this.srcMobile);
    }
}


// WEBPACK FOOTER //
// ./scripts/lib/MobileBg.js